function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:none;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill:#F1F2F3;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M36,194.6"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "st1",
  d: "M249.1,159.8v-34.3l0,0L249.1,159.8L249.1,159.8z M126.3,203.2c-1.4,1.7-3.2,3-5.3,3.8 c-4.8,1.7-10.2,0.3-13.4-3.6L78.9,169l-36,33.7v50.9h206.1v-93.8l-37.3-37.3L126.3,203.2z M249.1,47.5v78L220.6,97 c-4.6-4.6-12.1-4.8-16.9-0.2l-85.8,81.1l-28.6-34.2c-2.1-2.6-5.2-4.1-8.6-4.3c-3.3-0.2-6.6,1-9,3.3l-28.7,26.9v-122H249.1z  M113.7,99.4c0-10-8.2-18.2-18.2-18.2c-10,0-18,8.2-18,18.2c0,10,8,18,18,18C105.5,117.4,113.7,109.4,113.7,99.4z"
});

var SvgGalleryReverseIcon = function SvgGalleryReverseIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 288 288",
    style: {
      enableBackground: "new 0 0 288 288"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGalleryReverseIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gallery-reverse-icon.0a1f8f84.svg";
export { ForwardRef as ReactComponent };